<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h1 class="title mb-0">{{ pageTitleValue }}</h1>
      </div>
    </div>
    <div *ngIf="isSearchInput" class="row mt-3 gy-sm-2 search-container">
      <div class="col-12 col-sm">
        <input
          class="search-p"
          type="text"
          name="search"
          id="src_txt"
          [(ngModel)]="searchString"
          (keyup)="onInputKeyup()"
          (keydown.enter)="onSearchSubmit()"
          [placeholder]="placeholderValue"
        />
      </div>
      <div class="col-12 col-sm-auto">
        <button
          class="btn btn-psp-primary btn-search btn-block"
          (click)="onSearchSubmit()"
        >
          Search
        </button>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
